










import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  TConsuptionSearch,
  TConsuptionForm,
  TConsuptionPage
} from '@/types/views/school';
import { getCoursePackagePage } from '@/api/school';
const namespace = 'user'
@Component({
  components: {
    Search: () => import('./components/search.vue'),
    List: () => import('./components/list.vue')
  }
})
export default class Consuption extends Vue {
  // @State('orgId', {namespace})orgId!: string
  private consumptionSearch: TConsuptionSearch = {
    // orgId: '',
    pageSize: 20,
    currentPage: 1
  };
  private consumptionPage: TConsuptionPage = {};
  private activated() {
    this.getConsumptionData();
  }
  private handleConsumptionSearch(opts: TConsuptionForm) {
    this.consumptionSearch = { ...this.consumptionSearch, ...opts };
  }
  private async getConsumptionData() {
    try {
      let opts: any = {...this.consumptionSearch};  // , ...{orgId: this.orgId}
      let res: any = await getCoursePackagePage(opts);
      this.consumptionPage = res;
    } catch (e) {
      this.$message.error(e);
    }
  }
}
